import { RootState } from "@/app/stores"
import { blockUser, unblockUser } from "@/shared/api/users"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchBlockUser = createAsyncThunk<
    void,
    void,
    { state: RootState; rejectValue: ErrorType }
>('userBlock/fetchBlockUser', async (_, thunkAPI) => {
    const { currentUser, action } = thunkAPI.getState().userBlock
    if (!currentUser) return

    try {
        if (action === 'block') {
            await blockUser(currentUser.id)
        } else {
            await unblockUser(currentUser.id)
        }
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        } as ErrorType)
    }
})
